import { Component, OnInit, Input, Output, EventEmitter,ViewChild } from '@angular/core';
import { CompartirDatosService } from '@noe/services/compartirDatos.service';
import { ModalComponent } from 'src/app/shared/modal/modal.component';


@Component({
  selector: 'app-modal-visor',
  templateUrl: './modal-visor.component.html',
  styleUrls: ['./modal-visor.component.scss']
})
export class ModalVisorComponent implements OnInit {

  @Input('titleModal') title:string
  @Input('subtitle') subtitle:string
  @Input('loading') loading:boolean
  @Input('confirmText') confirmText:string = 'Confirmar'
  @Input('cancelText') cancelText:string = 'Cancelar'
  @Input('closeOnConfirm') closeOnConfirm:boolean = true
  @Input('disableConfirm') disableConfirm:boolean
  @Input('hide-footer') hideFooter:boolean
  @Input('big') big:boolean
  @Input('fullScreen') fullScreen:boolean
  @Input('auto-width') autoWidth:boolean
  @Input('scroller') scroller:boolean

  @ViewChild('modalCerrarVisor') modalCerrarVisor:ModalComponent;

  @Output() 
  onclose: EventEmitter<any> = new EventEmitter();
  @Output()
  onconfirm: EventEmitter<any> = new EventEmitter();

  isOpen:boolean

  constructor(
    public compartirDatosService: CompartirDatosService
  ) { }

  ngOnInit(): void {
  }

  open() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('modal-open');
    this.isOpen = true
  }

  close() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('modal-open');
    this.isOpen = false;
    this.onclose.emit();
    this.compartirDatosService.changeMessage(false);
  }

  confirm() {
    this.onconfirm.emit()
    if (this.closeOnConfirm) this.isOpen = false
  }

}
